// Qué de este sitio debe aparecer en Google y con qué dirección.
//
// CloudFront sirve el mismo index.html a tabularis.cl, a www y al subdominio
// de cada estudio, y para cualquier ruta, exista o no. Sin más, Google ve
// decenas de copias de la portada y reclama "Duplicada: el usuario no ha
// indicado ninguna versión canónica" (Search Console, 12-oct-2026). Acá se le
// dice cuál es la buena:
//   - en el dominio principal, cada página pública apunta a su dirección
//     limpia (sin ?ref= ni rutas inventadas);
//   - los paneles de los estudios y las páginas de cuenta no se indexan.
// El foro no pasa por acá: lo arma el servidor, con su propia canónica.
import { esApex } from './api';

const SITIO = 'https://tabularis.cl';

/** Ruta canónica de cada página pública. Términos y privacidad son la misma
 *  página, así que cuentan como una. */
const PUBLICAS: [RegExp, string][] = [
  [/^\/?$/, '/'],
  [/^\/chatbularis\/?$/, '/chatbularis'],
  [/^\/(terminos|privacidad|legal)\/?$/, '/terminos'],
];

function meta(nombre: string, valor: string) {
  let m = document.querySelector<HTMLMetaElement>(`meta[name="${nombre}"]`);
  if (!m) { m = document.createElement('meta'); m.name = nombre; document.head.appendChild(m); }
  m.content = valor;
}

export function fijarSeo(): void {
  if (typeof document === 'undefined') return;
  const ruta = window.location.pathname;
  const publica = esApex() ? PUBLICAS.find(([re]) => re.test(ruta))?.[1] : undefined;
  if (!publica) {
    // Panel de un estudio, consola, páginas de cuenta, Word, Drive o una ruta
    // que no existe (que igual muestra la portada).
    meta('robots', 'noindex');
    return;
  }
  let l = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!l) { l = document.createElement('link'); l.rel = 'canonical'; document.head.appendChild(l); }
  l.href = SITIO + publica;
}
